import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    globalFile: null,
    globalFiles: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const globalFileReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.GLOBALFILE_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.GLOBALFILE_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.GLOBALFILE_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default globalFileReducer;
